import React, { useState, useEffect } from 'react';
import './WhatsNewModal.css';

const WhatsNewModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const STORAGE_KEY = 'hasSeenWhatsNewV2_2_0';

  useEffect(() => {
    // Check if user has already seen this version's update
    const hasSeenUpdate = localStorage.getItem(STORAGE_KEY);
    if (!hasSeenUpdate) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    // Save to localStorage that user has seen this update
    localStorage.setItem(STORAGE_KEY, 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="whats-new-overlay">
      <div className="whats-new-modal">
        <div className="whats-new-header">
          <h2 className="whats-new-title">Välkommen till nya Aion Notes!</h2>
          <button
            className="whats-new-close"
            onClick={handleClose}
            aria-label="Stäng"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="whats-new-body">
          <div className="whats-new-intro">
            <p>
              Vi har gjort en stor uppdatering av Aion Notes för att ge dig en bättre
              och mer effektiv upplevelse. Här är några av de spännande nyheterna i
              denna release:
            </p>
          </div>

          <div className="whats-new-features">
            <h3>Nyheter i denna version:</h3>
            <ul className="whats-new-list">
              <li>
                <strong>Förbättrad transkribering</strong> - Snabbare och mer exakt
                tal-till-text med optimerad Whisper-integration
              </li>
              <li>
                <strong>Medicinsk terminologi</strong> - Nu kan du rapportera när Aion Notes
                har stavat en medicinsk term fel. Använd frågetecknet nere i högra hörnet för att
                rapportera detta
              </li>
              <li>
                <strong>Nytt användargränssnitt</strong> - Moderniserad design med
                förbättrad användarvänlighet
              </li>
              <li>
                <strong>Prestandaförbättringar</strong> - Snabbare laddningstider och
                smidigare användarupplevelse
              </li>
            </ul>
          </div>

          <div className="whats-new-footer-text">
            <p>
              Vi fortsätter att utveckla och förbättra Aion Notes baserat på din
              feedback. Tack för att du använder vår tjänst!
            </p>
          </div>
        </div>

        <div className="whats-new-footer">
          <button
            className="whats-new-understand-btn"
            onClick={handleClose}
          >
            Förstått
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsNewModal;